import { memo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { protocolColumns } from "../../Constants/protocolColumns";
import { toDateTime } from "../../Services/string.service";
import EmptyData from "../../components/EmptyData";

const DATE_FIELDS = ["eventDate", "reminderDate", "lastUpdate"];

const STATUS_COLORS = {
  1: "#dc3545", // vermelho
  2: "#90ee90", // verde claro
  3: "#fd7e14", // laranja
  4: "#198754", // verde escuro
};

function ProtocolGrid({ gridData, onViewDetails }) {
  const { t } = useTranslation();
  const columns = protocolColumns(t);

  const renderCell = (field, value) => {
    if (DATE_FIELDS.includes(field)) {
      return value ? toDateTime(value) : "";
    }

    return value ?? "";
  };

  if (!Array.isArray(gridData) || gridData.length === 0) {
    return <EmptyData />;
  }

  return (
    <div className="card">
      <div className="table-responsive text-nowrap">
        <table className="table table-grid" id="protocol-grid">
          <thead>
            <tr>
              <th></th>
              <th></th>
              {columns.map(({ field, header }) => (
                <th key={field}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody className="table-border-bottom-0">
            {gridData.map((item, index) => (
              <tr key={item.protocolId ?? index}>
                <td>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => onViewDetails(item)}
                  >
                    {t("PROTOCOLS.DETAILS_BUTTON")}
                  </button>
                </td>
                <td>
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-status-${item.protocolId ?? index}`}>
                        {item.protocolStatus}
                      </Tooltip>
                    }
                  >
                    <div
                      style={{
                        backgroundColor: STATUS_COLORS[item.protocolStatusId] ?? "#ced4da",
                        width: 15,
                        height: 15,
                        cursor: "help",
                      }}
                    />
                  </OverlayTrigger>
                </td>
                {columns.map(({ field }) => (
                  <td key={field}>{renderCell(field, item[field])}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default memo(ProtocolGrid);
